import * as React from 'react';
import { PageWrapper } from '../uiComponents/layout/PageWrapper';
import { ContentWrapper } from '../uiComponents/layout/ContentWrapper';
import { SectionGroup } from '../uiComponents/layout/SectionGroup';
import { ErrorWrapper } from '../uiComponents/ErrorWrapper';

export interface UniLoginDriftsProblemerProps {
}

export function UniLoginDriftsProblemer(props: UniLoginDriftsProblemerProps) {
    return (
        <PageWrapper>
            <ContentWrapper>
                <SectionGroup>
                    <ErrorWrapper header='UNI-Login driftsproblemer'>
                        <p>Der opleves desværre problemer med UNI-Login. Prøv igen senere.</p>
                    </ErrorWrapper>
                </SectionGroup>
            </ContentWrapper>
        </PageWrapper>
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/UniLoginDriftsProblemer.tsx